import { SVGProps } from 'react';

const Gift = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M18.25 12.75h-5.5v7.5H17A1.25 1.25 0 0 0 18.25 19v-6.25ZM5.75 19A1.252 1.252 0 0 0 7 20.25h4.25v-7.5h-5.5V19Zm14.5-10a.251.251 0 0 0-.25-.25h-7.25v2.5H20a.25.25 0 0 0 .25-.25V9Zm-16.5 2a.25.25 0 0 0 .25.25h7.25v-2.5H4a.25.25 0 0 0-.25.25v2Zm14.5-5.5a1.75 1.75 0 0 0-1.75-1.75h-.013c-.696-.013-1.446.322-2.142 1.095-.539.599-1.002 1.42-1.343 2.405H16.5a1.75 1.75 0 0 0 1.75-1.75Zm-12.5 0A1.752 1.752 0 0 0 7.5 7.25h3.498c-.34-.986-.804-1.806-1.343-2.405C8.96 4.072 8.21 3.737 7.513 3.75H7.5A1.75 1.75 0 0 0 5.75 5.5Zm14 0a3.25 3.25 0 0 1-.512 1.75H20l.173.008A1.75 1.75 0 0 1 21.75 9v2A1.752 1.752 0 0 1 20 12.75h-.25V19A2.752 2.752 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19v-6.25H4A1.75 1.75 0 0 1 2.25 11V9A1.75 1.75 0 0 1 4 7.25h.762a3.25 3.25 0 0 1 2.738-5v.002c1.228-.017 2.364.582 3.27 1.59.48.531.89 1.173 1.23 1.892.34-.72.75-1.36 1.23-1.893.906-1.007 2.042-1.607 3.27-1.59V2.25a3.25 3.25 0 0 1 3.25 3.25Z"
    />
  </svg>
);

export default Gift;
